module.exports = __webpack_public_path__ + "img/logo7.dc48a600.png";